import { Client } from '@/types/app';

export enum EAdType {
  USER_WEB_MAGAZINE_ARTICLE_CONTENT_BANNER = 'USER_WEB_MAGAZINE_ARTICLE_CONTENT_BANNER',
  USER_WEB_MOBILE_MAGAZINE_ARTICLE_CONTENT_BANNER = 'USER_WEB_MOBILE_MAGAZINE_ARTICLE_CONTENT_BANNER',
  USER_WEB_SEARCH_MAIN = 'USER_WEB_SEARCH_MAIN',
  USER_WEB_MOBILE_SEARCH_MAIN = 'USER_WEB_MOBILE_SEARCH_MAIN',
  USER_WEB_QNA_QUESTION_BOTTOM = 'USER_WEB_QNA_QUESTION_BOTTOM',
  USER_WEB_MOBILE_QNA_QUESTION_BOTTOM = 'USER_WEB_MOBILE_QNA_QUESTION_BOTTOM',
  USER_WEB_MENU_BOTTOM = 'USER_WEB_MENU_BOTTOM',
  USER_WEB_MOBILE_MENU_BOTTOM = 'USER_WEB_MOBILE_MENU_BOTTOM',
  USER_WEB_NON_BENEFIT_PRICE_MIDDLE = 'USER_WEB_NON_BENEFIT_PRICE_MIDDLE',
  USER_WEB_MOBILE_NON_BENEFIT_PRICE_MIDDLE = 'USER_WEB_MOBILE_NON_BENEFIT_PRICE_MIDDLE',
  USER_APP_SEARCH_MAIN_IMAGE = 'USER_APP_SEARCH_MAIN_IMAGE',
  USER_APP_MAGAZINE_ARTICLE_CONTENT_BANNER = 'USER_APP_MAGAZINE_ARTICLE_CONTENT_BANNER',
  USER_APP_QNA_QUESTION_BOTTOM_IMAGE = 'USER_APP_QNA_QUESTION_BOTTOM_IMAGE',
  USER_WEB_MOBILE_TOP_STICKY_BAND = 'USER_WEB_MOBILE_TOP_STICKY_BAND',
  USER_WEB_MOBILE_TOP_STICKY_BAND_BANNER = 'USER_WEB_MOBILE_TOP_STICKY_BAND_BANNER',
  USER_WEB_TOP_STICKY_BAND_BANNER = 'USER_WEB_TOP_STICKY_BAND_BANNER',
  USER_WEB_QNA_LIST_TOP_BANNER = 'USER_WEB_QNA_LIST_TOP_BANNER',
  USER_WEB_MOBILE_QNA_LIST_TOP_BANNER = 'USER_WEB_MOBILE_QNA_LIST_TOP_BANNER',
  USER_APP_QNA_HOME_TOP_BANNER = 'USER_APP_QNA_HOME_TOP_BANNER',
  USER_WEB_QNA_LIST_MIDDLE_NATIVE = 'USER_WEB_QNA_LIST_MIDDLE_NATIVE',
  USER_WEB_MOBILE_QNA_LIST_MIDDLE_NATIVE = 'USER_WEB_MOBILE_QNA_LIST_MIDDLE_NATIVE',
  USER_APP_QNA_HOME_MIDDLE_NATIVE = 'USER_APP_QNA_HOME_MIDDLE_NATIVE',
  USER_APP_QNA_LIST_MIDDLE_NATIVE = 'USER_APP_QNA_LIST_MIDDLE_NATIVE',
  USER_WEB_MOBILE_QNA_LOWEST_BOTTOM_BANNER = 'USER_WEB_MOBILE_QNA_LOWEST_BOTTOM_BANNER',
  USER_WEB_QNA_LOWEST_BOTTOM_BANNER = 'USER_WEB_QNA_LOWEST_BOTTOM_BANNER',
  USER_WEB_MOBILE_QNA_ANSWER_MIDDLE_BANNER = 'USER_WEB_MOBILE_QNA_ANSWER_MIDDLE_BANNER',
  USER_WEB_QNA_ANSWER_MIDDLE_BANNER = 'USER_WEB_QNA_ANSWER_MIDDLE_BANNER',
  USER_WEB_MOBILE_QNA_QUESTION_BOTTOM_BANNER = 'USER_WEB_MOBILE_QNA_QUESTION_BOTTOM_BANNER',
  USER_WEB_QNA_QUESTION_BOTTOM_BANNER = 'USER_WEB_QNA_QUESTION_BOTTOM_BANNER',
}

export enum EColorTheme {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}

export enum EClickActionType {
  OUT_LINK = 'OUT_LINK',
  PHONE_CALL = 'PHONE_CALL',
}

export enum AdPageType {
  MagazineDetail = 'MAGAZINE_DETAIL',
  Search = 'SEARCH',
  QnaDetailAnswerBottomBanner = 'QNA_DETAIL_ANSWER_BOTTOM_BANNER',
  Menu = 'MENU',
  NonBenefitDetail = 'NON_BENEFIT_DETAIL',
  TopCommonBanner = 'TOP_COMMON_BANNER',
  QnaHomeBanner = 'QNA_HOME_BANNER',
  QnaHomeNative = 'QNA_HOME_NATIVE',
  QnaListBanner = 'QNA_LIST_BANNER',
  QnaListNative = 'QNA_LIST_NATIVE',
  QnaDetailBottomBanner = 'QNA_DETAIL_BOTTOM_BANNER',
  QnaDetailAnswerMiddleBanner = 'QNA_DETAIL_ANSWER_MIDDLE_BANNER',
  QnaDetailQuestionBottomBanner = 'QNA_DETAIL_QUESTION_BOTTOM_BANNER',
}

export class BannerAdExchangeModel {
  private outLinkDomain = process.env.NEXT_PUBLIC_ADVERTISEMENT_OUTLINK || '';
  public adViewerOsPlatform: 'android' | 'ios' | 'web' | 'none' = 'none';

  private constructor(
    public bannerAdId: string,
    public bannerImageUrl: string | null,
    private colorTheme: EColorTheme,
    public deliberatedCode: string | null,
    public title: string | null,
    public subTitle: string | null,
    public longTitle: string | null,
    public longSubTitle: string | null,
    private clickActionType: EClickActionType | null,
    private _outLink: string | null,
    private _phoneNumber: string | null,
    public ctaButtonLabel: string | null,
    public targetPlace: string,
    public badges: { content: string }[],
    public content: string | null
  ) {}

  static fromBannerAdExchange(props: {
    bannerAdId: string;
    bannerImageUrl: string | null;
    colorTheme: EColorTheme;
    deliberatedCode: string | null;
    title: string | null;
    subTitle: string | null;
    longTitle: string | null;
    longSubTitle: string | null;
    clickActionType: EClickActionType | null;
    ctaButtonLabel: string | null;
    outLink: string | null;
    phoneNumber: string | null;
    targetPlaceCode: string;
    badges: { content: string }[];
    content: string | null;
  }): BannerAdExchangeModel {
    return new BannerAdExchangeModel(
      props.bannerAdId,
      props.bannerImageUrl,
      props.colorTheme,
      props.deliberatedCode,
      props.title,
      props.subTitle,
      props.longTitle,
      props.longSubTitle,
      props.clickActionType,
      props.outLink,
      props.phoneNumber,
      props.ctaButtonLabel,
      props.targetPlaceCode,
      props.badges,
      props.content
    );
  }

  get isLightTheme(): boolean {
    return this.colorTheme === EColorTheme.LIGHT;
  }
  get isDarkTheme(): boolean {
    return this.colorTheme === EColorTheme.DARK;
  }
  get isOutLink(): boolean {
    return this.clickActionType === EClickActionType.OUT_LINK;
  }

  get isPhoneCall(): boolean {
    return this.clickActionType === EClickActionType.PHONE_CALL;
  }

  get phoneNumber() {
    if (this.isPhoneCall) {
      return this._phoneNumber;
    }
    return null;
  }

  get buttonLabel() {
    return this.ctaButtonLabel ?? '바로 확인하기';
  }

  get outLink() {
    return this._outLink ? encodeURIComponent(this._outLink) : '';
  }

  private getOutLink(token: string | null = null): string | null {
    if (!this.isOutLink) {
      return null;
    }

    if (token && token.includes('//')) {
      return `${this.outLinkDomain}/${this.bannerAdId}?adViewerOsPlatform=${this.adViewerOsPlatform}&outlink=${this.outLink}${`&u=${btoa(token.split('//')[0])}`}&${Date.now().valueOf()}`;
    }

    return `${this.outLinkDomain}/${this.bannerAdId}?adViewerOsPlatform=${this.adViewerOsPlatform}&outlink=${this.outLink}${token ? `&u=${btoa(token)}` : ''}&${Date.now().valueOf()}`;
  }

  setAdViewerOsPlatformByClient(client: Client) {
    if (!client.isWebView) {
      this.adViewerOsPlatform = 'web';
      return;
    }
    if (client.isAndroid) {
      this.adViewerOsPlatform = 'android';
    } else if (client.isIOS) {
      this.adViewerOsPlatform = 'ios';
    } else {
      this.adViewerOsPlatform = 'none';
    }
  }

  getLink(token: string | null = null): string {
    if (this.isOutLink) {
      return this.getOutLink(token) ?? '';
    }
    if (this.isPhoneCall) {
      return `tel:${this.phoneNumber}`;
    }
    return '';
  }

  action(token: string | null = null, callback?: (bannerAdExchange: BannerAdExchangeModel) => void) {
    callback?.(this);

    if (this.isOutLink) {
      window.open(this.getOutLink(token) ?? '', '_blank');
      return;
    }
    if (this.isPhoneCall) {
      document.location.href = `tel:${this.phoneNumber}`;
      return;
    }
  }
}
